import { Suspense, useEffect, useState } from 'react'
import { Outlet } from 'react-router'
import { Sidebar } from './Sidebar.js'
import { CommandPalette } from './CommandPalette.js'
import { Toaster } from './Toaster.js'
import { InstanceBanner } from './InstanceBanner.js'
import { RouteFallback } from '../app/RouteFallback.js'

export function Shell() {
  const [paletteOpen, setPaletteOpen] = useState(false)

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault()
        setPaletteOpen((open) => !open)
      }
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [])

  return (
    <div className="stack" style={{ height: '100%' }}>
      <InstanceBanner />
      <div className="row" style={{ flex: 1, minHeight: 0, alignItems: 'stretch' }}>
        <Sidebar onOpenPalette={() => setPaletteOpen(true)} />
        <div className="stack" style={{ flex: 1, minWidth: 0, minHeight: 0, overflow: 'auto' }}>
          {/* The sidebar (and the rest of Shell) stays mounted while a lazy
              route's code loads — only the content area shows the fallback. */}
          <Suspense fallback={<RouteFallback />}>
            <Outlet context={{ openPalette: () => setPaletteOpen(true) }} />
          </Suspense>
        </div>
      </div>
      <CommandPalette open={paletteOpen} onClose={() => setPaletteOpen(false)} />
      <Toaster />
    </div>
  )
}
